/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-02-23 11:05:55
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-03-27 14:46:44
 * @FilePath: \qctsw-vue\packages\app\src\logic\news\banner.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { LOAD_STATE } from '@/shared/types'
import type { HomeBannerData } from '@/server/types'
import { getNewsBannerDataApi } from '@/server'

export function logicNewsBanner() {
  const state = ref<LOAD_STATE>(LOAD_STATE.INIT)
  const bannerData = ref<Omit<HomeBannerData, 'complain'>>({
    bannres: [],
    articles: [],
  })

  async function getBannerData() {
    const res = await useLoadState({
      key: `资讯首页banner数据`,
      state,
      fn: getNewsBannerDataApi,
    })

    if (res?.data)
      bannerData.value = res.data
  }

  return {
    state,
    bannerData,
    getBannerData,
  }
}
